import React from 'react';
import { Form, Button, Input, Select } from 'antd';
import { AddClassWrapper } from './class.style';

import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useGrade } from 'features/routine/hooks/useGrade';
import { formatTime } from 'common/helper/timeFormatter';
import moment from 'moment';

export const AddClassDetails = (props: any) => {
  const { onSaveGrade } = useGrade();
  const [form] = Form.useForm();
  const { onVisibleChange, onSetReloadGrade } = props;
  const grade = useSelector((state: RootState) => state.grade);
  const { fetchGrade } = useGrade();
  const handleSubmit = () => {
    onSaveGrade(
      {
        ...form.getFieldsValue(),
        startTime: moment(form.getFieldsValue().startTime, 'hh:mm a').format('hh:mm:ss A'),
        endTime: moment(form.getFieldsValue().endTime, 'hh:mm a').format('hh:mm:ss A'),
      },
      form,
      onVisibleChange,
      onSetReloadGrade,
    );
  };
  React.useEffect(() => {
    fetchGrade();
  }, []);

  return (
    <AddClassWrapper>
      <Form form={form} size="large" layout="vertical">
        <Form.Item name="value" label="Grade">
          <Input />
        </Form.Item>
        <Form.Item name="startTime" label="Start Time">
          <Input type="time" placeholder="09:00:00 AM" />
        </Form.Item>
        <Form.Item name="endTime" label="End Time">
          <Input
            type="time"
            placeholder="04:00:00 PM"
            onChange={(e) => {
              console.log(e.target.value);
            }}
          />
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" onClick={handleSubmit}>
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </AddClassWrapper>
  );
};

export default AddClassDetails;
